/**
 *
 * @page 用户中心/我的方案/项目管理/项目详情
 *
 **/
import React from 'react';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import SchemeDetailTab from '@/components/UserCenter/SchemeDetailTab';
import ProjectTurbineTab from '@/components/UserCenter/ProjectTurbineTab';
import ChangeHistoryTab from '@/components/UserCenter/ChangeHistoryTab';
import { useLocation, useHistory } from 'react-router-dom';
import ProjectInfoTab from '&/components/ProjectSpace/ProjectInfoTab';

const ProjectDetail = props => {
    const location = useLocation();
    const history = useHistory();
    const SEARCH = new URLSearchParams(location.search);
    const projectId = SEARCH.get('id');
    const TAB_NUM = SEARCH.get('tab');
    const [payStatus, setPayStatus] = useState(
        location.state?.projectStatus || '3'
    );

    const updateData = (status, name) => {
        setPayStatus(status);
        props.setBreadcrumb(name);
    };

    useEffect(() => {
        return () => {
            props.setBreadcrumb('');
        };
    }, []);

    useEffect(() => {
        onStatusChange(payStatus);
    }, [payStatus]);

    const TABS = [
        {
            name: intl.get('projectSpace.schemeDetail'), // 方案详情
        },
        {
            name: intl.get('projectSpace.projectTurbine'), // 项目成员
        },
        {
            name: intl.get('projectSpace.projectInfo'),
        },
        {
            name: intl.get('projectSpace.changeHistory'),
        },
    ];
    const [tags, setTags] = useState([TABS[2]]);
    const [activeTab, setActiveTab] = useState(0);
    const [headerRight, setheaderRight] = useState();

    useEffect(() => {
        if (activeTab && TAB_NUM) {
            if (activeTab !== TAB_NUM - 0) {
                location.search = '?id=' + SEARCH.get('id');
                history.replace(location.search);
            }
        }
    }, [activeTab]);

    function returnButton(el) {
        setheaderRight(el);
    }

    const CONTENT = [
        <SchemeDetailTab pId={projectId} renderFn={returnButton} />,
        <ProjectTurbineTab pId={projectId} renderFn={returnButton} />,
        <ProjectInfoTab updateStatus={updateData} />,
        <ChangeHistoryTab pId={projectId} />,
    ];

    function onStatusChange(status) {
        if (['1', '5'].includes(status)) {
            setTags(TABS);
            setContent(CONTENT);
            setActiveTab(TAB_NUM - 0 || 2);
        } else {
            setTags([TABS[2]]);
            setContent([CONTENT[2]]);
        }
    }

    const [content, setContent] = useState(CONTENT);

    const onTabChange = (e, i) => {
        setActiveTab(i);
        [2, 3].includes(i) && setheaderRight();
    };

    return (
        <BasePageWrap
            className="project-detail"
            defaultActive={activeTab}
            type={(activeTab === 0) & (tags.length > 1) ? '' : 'card'}
            tabs={tags}
            headerRight={headerRight}
            onTabChange={onTabChange}>
            {content[activeTab]}
        </BasePageWrap>
    );
};

export default ProjectDetail;
